import { createStore, compose, applyMiddleware } from 'redux'
import rootReducer from '../reducers/index'
import createSagaMiddleware from 'redux-saga'
import { responsiveStoreEnhancer } from 'redux-responsive'
import { syncHistoryWithStore } from 'react-router-redux'
import { browserHistory } from 'react-router'
import rootSaga from '../sagas/sagas'
import { defaultState } from './defaultState'
import { autoLogin, listenForAuthChangesInAllTabs } from './util'

let composeEnhancers = compose

// check for dev-tools availability in the browser
if (process.env.NODE_ENV === 'development') {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
}

// create the saga middleware
const sagaMiddleware = createSagaMiddleware()

//create store and apply middleware
const store = createStore(
  rootReducer,
  defaultState,
  composeEnhancers(applyMiddleware(sagaMiddleware), responsiveStoreEnhancer)
)

// run the saga middleware with the rootSaga
sagaMiddleware.run(rootSaga)

// login user if previous auth data is found
autoLogin(store)

// make sure login/logout in other tabs is picked up by the app
listenForAuthChangesInAllTabs(store)

// make sure we have access to the router in redux store
export const history = syncHistoryWithStore(browserHistory, store)

export function getAuthToken() {
  return store.getState().auth.token
}

export function getUserType() {
  return store.getState().auth.userType
}

export default store



// WEBPACK FOOTER //
// ./src/store/configStore.js